/* global angular*/
import './style.less';

export default function($scope) {
  'ngInject';

  const vm = this;
  let index = 0;

  vm.$onChanges = () => {
    vm.ngModel.length = 0;
    if (vm.data.length) activate();
  };

  vm.showMore = () => {
    index += vm.pageSize;
    if (index < vm.data.length) {
      const chunk = vm.data.slice(index, index + vm.pageSize);
      vm.ngModel.push(...chunk);
    } else vm.hideShowMore = true;
  };

  const container = angular.element('.table-container');
  container.bind('scroll', function() {
    const remaining = container[0].scrollHeight - (container[0].clientHeight + container[0].scrollTop);
    if (remaining < 50) {
      index += vm.pageSize;
      if (index < vm.data.length) {
        const chunk = vm.data.slice(index, index + vm.pageSize);
        vm.ngModel.push(...chunk);
      } else vm.hideShowMore = true;
      $scope.$apply();
    }
  });

  function activate() {
    index = 0;
    const slice = vm.data.slice(0, vm.pageSize);
    vm.ngModel.push(...slice);
    if (vm.ngModel.length < vm.pageSize) vm.hideShowMore = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/infiniteScroll/controller.js